import { AppointmentID } from "./Appointment";
import { PublicAccountID } from "./Publicaccount";
import { User, UserID } from "./User";

export type AppointmentNoteID = number;

export type AppointmentNoteAttachmentID = number;

export enum APPOINTMENT_NOTE_TYPES {
  WO = 1,
  Main = 2,
  CallCustomer = 3,
  OptionalNoteTypeFirst = 4,
  BackOrder = 4,
  Info = 5,
  Attachment = 6,
  Bill = 7,
  Tyrescanner = 8,
  TempDriver = 9,
  RecurringCar = 10,
  ParkingLocation = 11,
  DMS = 12,
  MakeAnOffer = 13,
  ReplacementVehicle = 14,
  NoDrive = 15,
  HighVoltageWarning = 16,
  XentryAttachment = 17
}

export interface AppointmentNote {
  created_on: string;
  updated_on: string;
  id: AppointmentNoteID;
  appointment_note_type_id: APPOINTMENT_NOTE_TYPES; // Type of the appointment note
  appointment_id: AppointmentID; // Identifier of the appointment this note belongs to
  created_by_id: UserID; // Identifier of the user who created the note
  public_account_id: PublicAccountID | null; // Identifier of the public account, if note is added by the public API
  updated_by_id: UserID | null; // Identifier of the user who last updated the note
  note: string; // Content of the note
  visible_to_mechanic: boolean; // Whether the note is visible to the mechanic
  backorder_date: string | null; // Expected date for backordered parts or items to arrive
  name: string; // Name associated with the note (e.g., customer)
  phone_nr: string; // Phone number associated with the note
  email: string; // Email address associated with the note
  reg_nr: string; // Vehicle registration number
  rental_pickup_time: string | null; // Scheduled time for rental vehicle pickup
  rental_drop_off_time: string | null; // Scheduled time for rental vehicle return
  dms_nr: string | null; // Identifier from the Dealer Management System
  is_kiosk_check_in_note: boolean; // If true, then this note is added during the kiosk check-in by customer, this is exclusive for parking note type.
  created_by?: User;
  updated_by?: User;
  attachments?: AppointmentNoteAttachment[];
}

export interface AppointmentNoteAttachment {
  created_on: string;
  updated_on: string;
  id: AppointmentNoteAttachmentID;
  name: string; // Original name of the attachment file
  url: string; // Internal URL where the attachment is stored
  type: string; // MIME type or classification of the attachment (e.g., image/jpeg, application/pdf)
  user_id: UserID; // Identifier of the user who uploaded the attachment
  appointment_note_id: AppointmentNoteID; // Identifier of the appointment note the attachment is associated with
  external_source: string; // Source/Origin of the attachment in external system
  username?: string;
}
